module.exports = __webpack_public_path__ + "static/media/IMG_4490.6a6dc91f.jpg";